// extracted by mini-css-extract-plugin
export default {"container":"Option_container__bb-Ue","option":"Option_option__dP-I3","label":"Option_label__hf02y"};